<ng-container [ngSwitch]="style?.type">
  <a
    [href]="link.short_url"
    target="_blank"
    *ngSwitchCase="'basic'"
    mat-button
    color="accent"
    [ngClass]="style?.variant"
    [style.background-color]="style?.color"
  >
    <image-or-icon class="inherit-size" [src]="link.image" *ngIf="link.image"></image-or-icon>
    <div class="content">{{ link.name }}</div>
  </a>
  <a
    [href]="link.short_url"
    target="_blank"
    *ngSwitchCase="'stroked'"
    mat-stroked-button
    color="accent"
    [ngClass]="style?.variant"
    [style.background-color]="style?.color"
  >
    <image-or-icon class="inherit-size" [src]="link.image" *ngIf="link.image"></image-or-icon>
    <div class="content">{{ link.name }}</div>
  </a>
  <a
    [href]="link.short_url"
    target="_blank"
    *ngSwitchCase="'flat'"
    mat-flat-button
    color="accent"
    [ngClass]="style?.variant"
    [style.background-color]="style?.color"
  >
    <image-or-icon class="inherit-size" [src]="link.image" *ngIf="link.image"></image-or-icon>
    <div class="content">{{ link.name }}</div>
  </a>
  <a
    [href]="link.short_url"
    target="_blank"
    *ngSwitchDefault
    mat-raised-button
    color="accent"
    [ngClass]="style?.variant"
    [style.background-color]="style?.color"
  >
    <image-or-icon class="inherit-size" [src]="link.image" *ngIf="link.image"></image-or-icon>
    <div class="content">{{ link.name }}</div>
  </a>
</ng-container>
